import React from "react";
import HeaderContainer from "./Header";
import { Card, Flex, Heading, Stack, Text } from "@chakra-ui/react";
import { Button } from "../components/ui/button";

const Maintenance: React.FC = () => {
  return (
    <Flex
      minHeight="100vh"
      width="100%"
      maxWidth="1392px"
      margin="0 auto"
      paddingTop="24px"
      paddingBottom="24px"
      direction="column"
      gap="24px"
    >
      {/* Header */}
      <HeaderContainer behavior="maintenance" />

      {/* Main container to center the content */}
      <Flex flex={1} justifyContent="center" alignItems="center" padding="20px">
        {/* Content wrapper for max width */}
        <Stack maxWidth="480px" width="100%" alignItems="center" gap={8}>
          {/* Page title */}
          <Heading
            as="h1"
            textAlign="center"
            color="#18181b"
            fontSize="24px"
            fontWeight="bold"
            letterSpacing="-0.4px"
            lineHeight="32px"
          >
            We’ll Be Back Shortly
          </Heading>

          {/* Maintenance Card */}
          <Card.Root width="100%">
            <Card.Body>
              <Stack gap={4} alignItems="center" textAlign="center">
                <Text fontSize="md" color="#52525b" lineHeight="24px">
                  We’re currently updating the CoinCap dashboard. During this time, the CoinCap API will remain 100% functional with no expected interruptions.
                </Text>

                <Text fontSize="md" color="#52525b" lineHeight="24px">
                  For any questions or concerns, please visit our Discord server where you can ask questions or submit a support ticket.
                </Text>

                {/* Discord CTA */}
                <Button colorPalette="purple" bg="#9333ea" asChild>
                  <a
                    href="https://mee6.xyz/en/i/S3ZfymIhLR"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Join the CoinCap Discord
                  </a>
                </Button>
              </Stack>
            </Card.Body>
          </Card.Root>
        </Stack>
      </Flex>
    </Flex>
  );
};

export default Maintenance;
